// Shared constants for ExceptionList components to avoid circular dependencies
export const EXCEPTION_LIST_COLUMNS = {
  AVATAR: { width: 28, marginRight: 20 },
  DOB: {
    width: 45,
    marginRight: 16,
  },
  NAME: { width: 170, marginRight: 12 },
  NOTE: {
    width: 40,
    marginRight: 30,
    justifyContent: "center",
  },
  ATTENDANCE: {
    width: 104,
    marginRight: 30,
    justifyContent: "center",
  },
  ROOM: { width: 160, marginRight: 0 }, // No gap after last column
}

export const EXCEPTION_LIST_VIEWS = {
  all: "all",
  assistants: "assistants",
  tryouts: "tryouts",
  makeups: "makeups",
  plannedAbsences: "plannedAbsences",
}
